
export const defaultTheme = {
    green: "#DDF45B",
    darkBlue: "#0D1520",
    lightBlue: "#F4F7FA",
    white: "#FFFFFF",
    grey: "#8B939C"
}